import { Controller } from "@hotwired/stimulus"

// tag_owners/index: toggling a tag's active/inactive checkbox PUTs the new
// state, then moves that tag's card into the other container and updates
// both counts -- no full-page re-render needed. Plain fetch/DOM, no
// jQuery dependency (this page never had one).
export default class extends Controller {
  static targets = ["activeContainer", "inactiveContainer", "activeCount", "inactiveCount"]

  toggle(event) {
    const tagId = event.target.dataset.id
    const isActive = event.target.checked

    fetch(`/tag_owners/${tagId}`, {
      method: "PUT",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ tag_owner: { is_active: isActive } }),
    })
      .then((response) => response.json())
      .then((data) => {
        const tagElement = document.getElementById(`tag-${data.id}`)
        const targetContainer = data.is_active ? this.activeContainerTarget : this.inactiveContainerTarget

        tagElement.querySelector('input[type="checkbox"]').checked = data.is_active
        targetContainer.prepend(tagElement)
        this.updateCounts()
      })
  }

  updateCounts() {
    this.activeCountTarget.textContent = this.activeContainerTarget.querySelectorAll(".tag-item").length
    this.inactiveCountTarget.textContent = this.inactiveContainerTarget.querySelectorAll(".tag-item").length
  }
}
